import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import PaginaInicial from "./paginas/PaginaInicial";
import PaginaBot from "./paginas/PaginaBot";
import PaginaLogin from "./paginas/PaginaLogin";
import RodapeMetricas from "./componentes/RodapeMetricas";
import { AuthProvider, useAuth } from "./contextos/AuthContext";
import "./App.css";

function PortaoAutenticado() {
    const { usuario, verificando } = useAuth();
    if (verificando) {
        // Tela de splash mínima (mesma cor de fundo, sem texto pra não piscar)
        return <div className="min-h-screen bg-zinc-950" />;
    }
    if (!usuario) return <PaginaLogin />;
    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<PaginaInicial />} />
                    <Route path="/bots/:id" element={<PaginaBot />} />
                </Routes>
            </BrowserRouter>
            <RodapeMetricas />
        </>
    );
}

function App() {
    return (
        <div className="App min-h-screen bg-zinc-950">
            <AuthProvider>
                <PortaoAutenticado />
            </AuthProvider>
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: { background: "#18181b", border: "1px solid #27272a", color: "#fafafa", fontSize: 12 },
                }}
            />
        </div>
    );
}

export default App;
